import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { ReportsService } from '../reports.service';

import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { UserTrans } from '../userTrans.model';
import { Users } from 'src/app/options/users/users.model';
import { OptionService } from 'src/app/options/option.service';
import { LocalStorageService } from 'ngx-webstorage';
import { MandoobService } from 'src/app/options/mandoobs/mandoob.service';
import { Customer } from 'src/app/options/customer.model';
import { ExportexcelService } from '../exportexcel.service';

@Component({
  selector: 'app-mandoobtrans',
  templateUrl: './mandoobtrans.component.html',
  styleUrls: ['./mandoobtrans.component.css']
})
export class MandoobtransComponent implements OnInit {

  reports: UserTrans[] = [];
  users: Users[] = [];
  mandoobs: { id: number, name: string }[] = [];

  displayedColumns: string[] = ['date', 'amount'];
  dataSource!: MatTableDataSource<UserTrans>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild('fromDate') fromDate!: ElementRef;
  @ViewChild('toDate') toDate!: ElementRef;


  spinnerOverlay = false;
  selectedUser!: number;
  lang = 'en';
  reportObj: UserTrans = {} as UserTrans;
  pageSize = 100;

  constructor(private service: ReportsService,
    private mandoobService: MandoobService,
    private optionService: OptionService,
    private globle: Globle,
    private excelService: ExportexcelService,
    private localStorage: LocalStorageService) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.getManddobs();
  }

  getManddobs() {
    this.spinnerOverlay = true;
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)

    })
  }

  get() {
    this.spinnerOverlay = true;
    this.service.userTransForMandoob(this.selectedUser, this.fromDate.nativeElement.value, this.toDate.nativeElement.value).subscribe(data => {

      this.reports = data;

      this.dataSource = new MatTableDataSource(this.reports);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.reports = [];
        this.dataSource = new MatTableDataSource(this.reports);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
  }

  onApply() {
    this.get();
  }

  getTotalDeposit() {
    return this.reports.map(t => t.amount).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  exportAsXLSX(): void {
    var exportList = [];
    for (let i = 0; i < this.reports.length; i++) {
      var obj = {
        "التاريخ": this.reports[i].date,
        "المبلغ": this.reports[i].amount
      }

      exportList.push(obj);
    }
    this.excelService.exportAsExcelFile(exportList, 'تقرير مبيعات مندوب');
  }

}
